import { components } from 'react-select'
import { getValueFromResource } from '../../../common/timeLiveFunction'
import { useAppDispatch } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';

export const makeMenuListWithAdd = ( onAdd: (name: string) => Promise<void>, loading: boolean) =>
    ({ children, ...props }: any) => {
        const dispatch = useAppDispatch();
        const { t } = useTranslation();
        const inputValue = props.selectProps?.inputValue || ''
        const options = props.selectProps?.options || []
        const hasMatch = options.some((opt: any) => opt.label?.toLowerCase().includes(inputValue.toLowerCase()))
        const showAddButton = inputValue.trim().length > 0 && !hasMatch

        return (
            <components.MenuList {...props}>
                {children}

                {showAddButton && (
                    <div
                        onMouseDown={e => e.preventDefault()}
                        style={{
                            padding: '8px 10px',
                            borderTop: '1px solid #f0f0f0',
                        }}
                    >
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            disabled={loading}
                            style={{ width: '100%', padding: '7px 12px', borderRadius: '7px' }}
                            onMouseDown={e => {
                                e.preventDefault()
                                onAdd(inputValue.trim())
                            }}
                        >
                            {getValueFromResource('+ Zone Type', dispatch, t)}
                        </button>
                    </div>
                )}
            </components.MenuList>
        )
    }